import { MAX_BUNDLE_PRODUCTS } from '../../bundle.machine.constants';
import { type BundleMachineGuard } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Whether the bundle has room for another product.
 */
export const checkIfCanSelectMore: BundleMachineGuard = (guardArgs) => {
  const { context } = guardArgs;

  return context.selectedProducts.length < MAX_BUNDLE_PRODUCTS;
};
